export const environment = {
    baseUrl: '',
    production: true,
    apiURL: 'https://dev-api-order.posapp.vn/v1',
    setDefaultLang: 'vi',
    clientId: 'mnRZ6u9DWm',
    clientSecret: 'HdhClxkTjFyV295PfGH9AgHKv86MOyeZ',
    firebase: {
        apiKey: 'AIzaSyDTUq_qBapMb77-mQtumUcqXlqO7xPuels',
        authDomain: 'user-system-test.firebaseapp.com',
        databaseURL: 'https://user-system-test-default-rtdb.asia-southeast1.firebasedatabase.app',
        projectId: 'user-system-test',
        storageBucket: 'user-system-test.appspot.com',
        messagingSenderId: '290795850068',
        appId: '1:290795850068:web:0cfcee004e5f54d40fa0c1'
    },
    version: '2.1.0+3',
    sentryEnvironment: 'fnb-development',
    appType: 'fnb',
    ga: undefined
};
